<template>
  <v-modal name="parameters" @callback="setLinkableProperty" @modalHide="clearLinkableProperty" :keep-alive="true">
    <v-panel class="v-parameters">
      <template v-slot:header>
        <div class="flex flex-center space-between">
          <h4>
            <v-icon name="sliders" />
            {{ $t('Parameters') }}
          </h4>

          <ul class="actions">
            <li>
              <button class="small secondary rounded" @click="modal.show('parameter-edit')">
                <v-icon name="plus" />
                {{ $t('Add Manually') }}
              </button>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:default>
        <VSearchableTree @node-selected="selectNode" />
      </template>
    </v-panel>
    <v-modal name="parameter-edit" @modalHide="clearNode">
      <v-create @create-parameter="addLinkedParameter" :data="selectedNode" />
    </v-modal>
  </v-modal>
</template>
<script lang="ts" setup>
import { $t } from '/@/i18n'
import { NodeType } from '/@/shared/actions/SearchMotorcortexTree'
import { nextTick, ref } from 'vue'
import { useModal } from '@vectioneer/ui'
import { useStore } from '/@/shared/composables/store'
import { Entry } from '/@/shared/entities/Entry'
import { Mapping } from '/@/shared/entities/Mapping'
import vCreate from './create/index.vue'
import VSearchableTree from '/@/shared/components/searchable-tree/index.vue'

const modal = useModal()
const { ethercat } = useStore()

const selectedNode = ref<any>(null)
const linkableProperty = ref<Entry | Mapping | null>(null) // TODO: type

const addLinkedParameter = (data: any) => {
  // TODO: type
  ethercat.addLinkedParameter({
    item: linkableProperty.value,
    ...data,
  })

  modal.hide('parameter-edit')
  modal.hide('parameters')
}

const setLinkableProperty = (property: Entry | Mapping | null) => {
  linkableProperty.value = property
}

const clearLinkableProperty = () => {
  setLinkableProperty(null)
}

const selectNode = (event: { node?: NodeType; info: any; channel?: any }) => {
  selectedNode.value = {
    ...event.info,
    gain: 1,
    divide: 1,
    gainOffset: 0,
    channel: event.channel ?? null,
  }

  nextTick(() => modal.show('parameter-edit'))
}

const clearNode = () => {
  selectedNode.value = null
}
</script>
<style src="./style.css"></style>
